exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sk-folding-cube{width:27px;height:27px;position:relative;transform:rotate(45deg)}.sk-folding-cube>div{background-color:initial;float:left;width:50%;height:50%;position:relative;transform:scale(1.1)}.sk-folding-cube>div:before{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-color:currentColor;animation:sk-foldCubeAngle 2.4s infinite linear both;transform-origin:100% 100%}.sk-folding-cube>div:nth-child(2){transform:scale(1.1) rotate(90deg)}.sk-folding-cube>div:nth-child(4){transform:scale(1.1) rotate(180deg)}.sk-folding-cube>div:nth-child(3){transform:scale(1.1) rotate(270deg)}.sk-folding-cube>div:nth-child(2):before{animation-delay:.3s}.sk-folding-cube>div:nth-child(4):before{animation-delay:.6s}.sk-folding-cube>div:nth-child(3):before{animation-delay:.9s}@keyframes sk-foldCubeAngle{0%,10%{transform:perspective(140px) rotateX(-180deg);opacity:0}25%,75%{transform:perspective(140px) rotateX(0deg);opacity:1}90%,to{transform:perspective(140px) rotateY(180deg);opacity:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-spinkit/css/folding-cube.css
// module id = 840
// module chunks = 0